import NetworkIndicator from "./NetworkIndicator";
export default NetworkIndicator;
